import { useUIStore } from "@/stores/ui";
export default function guest({ next, store, from }) {
  let isAuthenticated = !!store.token && !!localStorage.getItem("key");
  if (isAuthenticated) {
    return next(from.path);
  }

  useUIStore().layout = "layout-plain";

  return next();
}
